var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"errorPage"},[_c('h1',{staticClass:"mb-8"},[_vm._v(" "+_vm._s(_vm.$t("forbiddenPage"))+" ")]),_c('v-btn',{attrs:{"depressed":"","color":"primary","to":{name:'Home'}}},[_vm._v("Retour a l'accueil")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }